import { gql } from '@apollo/client';

const schema = {
  get: {
    name: "users",
    serviceName: "unitadmin",
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            id
            lastname
            firstname
          }
        }
      }
    `,
  },
};

export default schema;
